<app-header *ngIf="urlParamsService.params.tab"></app-header>
<div class="d-flex">
  <app-taxonomy *ngIf="urlParamsService.params.sidebar" mainTitle="{{ 'menu.settings' | translate }}">
    <a *ngIf="urlParamsService.params.configPersonal" routerLink="/perfil" routerLinkActive="current" [routerLinkActiveOptions]="{ exact: true }" class="taxonomy-option"
      ><i class="fa-regular fa-user"></i> {{ 'profile.personalInfo' | translate }}</a
    >
    <a
      *ngIf="urlParamsService.params.configSecurity && !appService.isEnterpriseChild && appService.isAutentiqueDomain() && !enterpriseService.hideForEnterprise()"
      routerLink="/perfil/seguranca"
      routerLinkActive="current"
      class="taxonomy-option"
      ><i class="fa-regular fa-shield"></i> {{ 'profile.security' | translate }}</a
    >
    @if ((urlParamsService.params.configAppearance && canShowAppearanceByDate()) || !appService.isAutentiqueDomain()) {
      <a
        [routerLink]="['/perfil', appService.isAutentiqueDomain() && !enterpriseService.hideForEnterprise() ? 'aparencia' : 'emails']"
        [routerLinkActive]="appService.isAutentiqueDomain() ? 'current' : ''"
        class="taxonomy-option"
        ><i class="fa-regular fa-paint-brush-alt"></i> {{ 'menu.appearance' | translate }}</a
      >
    }
    <a *ngIf="urlParamsService.params.configNotifications" routerLink="/perfil/notificacoes" routerLinkActive="current" class="taxonomy-option"
      ><i class="fa-regular fa-bell"></i> {{ 'menu.notification' | translate }}</a
    >
    @if (urlParamsService.isConfigOrganizationActive()) {
      <hr />
      <div class="taxonomy-separator">{{ 'menu.organization' | translate }}</div>
    }
    @if (!enterpriseService.hideForEnterprise()) {
      <a *ngIf="urlParamsService.params.configGeneral" routerLink="/perfil/organizacao" routerLinkActive="current" class="taxonomy-option"
        ><i class="fa-regular fa-cog"></i> {{ 'menu.settingsGeneral' | translate }}</a
      >
      <a *ngIf="urlParamsService.params.configPlans && !appService.isEnterpriseChild && appService.isAutentiqueDomain()" routerLink="/perfil/planos" routerLinkActive="current" class="taxonomy-option"
        ><i class="fa-regular fa-credit-card"></i> {{ (!currentUser?.organization?.parent ? 'menu.plansPayment' : 'menu.additionalValidation') | translate }}</a
      >
    }
    <a *ngIf="urlParamsService.params.configEmails" routerLink="/perfil/emails" routerLinkActive="current" class="taxonomy-option"
      ><i class="fa-regular fa-envelope"></i> {{ 'menu.emails' | translate }}</a
    >
    @if (!enterpriseService.hideForEnterprise()) {
      <a *ngIf="urlParamsService.params.configMembers" routerLink="/perfil/membros" routerLinkActive="current" class="taxonomy-option"
        ><i class="fa-regular fa-users"></i> {{ 'menu.members' | translate }}</a
      >
      <a *ngIf="urlParamsService.params.configGroups" routerLink="/perfil/grupos" routerLinkActive="current" class="taxonomy-option"
        ><i class="fa-regular fa-users-class"></i> {{ 'menu.groups' | translate }}</a
      >
    }
    <a *ngIf="urlParamsService.params.configWebhooks" routerLink="/perfil/webhooks" routerLinkActive="current" class="taxonomy-option"
      ><i class="fa-regular fa-brackets-curly"></i> {{ 'menu.webhooks' | translate }}</a
    >
    <a
      routerLink="/perfil/personalizacao"
      *ngIf="currentUser?.currentPermissions.change_whitelabel_oz && urlParamsService.params.configCustomization"
      routerLinkActive="current"
      class="taxonomy-option"
      ><i class="fa-regular fa-palette"></i> {{ 'menu.customization' | translate }}</a
    >
    @if (urlParamsService.isConfigDeveloperActive() || canShowOAuthClientsMenu()) {
      <hr />
      <div class="taxonomy-separator">{{ 'menu.developer' | translate }}</div>
    }
    @if (urlParamsService.params.configApi) {
      <a routerLink="/perfil/api" routerLinkActive="current" class="taxonomy-option"><i class="fa-regular fa-key"></i> {{ 'menu.accessApi' | translate }}</a>
    }
    @if (canShowOAuthClientsMenu()) {
      <a routerLink="/perfil/aplicativos" routerLinkActive="current" class="taxonomy-option"><i class="fa-regular fa-grid-2-plus"></i> {{ 'menu.oauthClients' | translate }}</a>
    }
    @if (currentUser?.created_at < '2021-02') {
      @if (urlParamsService.isConfigOtherActive()) {
        <hr />
        <div class="taxonomy-separator">{{ 'menu.other' | translate }}</div>
      }
      <a *ngIf="urlParamsService.params.configReferral" routerLink="/perfil/indicacoes" routerLinkActive="current" class="taxonomy-option"
        ><i class="fa-regular fa-heart"></i> {{ 'menu.indications' | translate }}</a
      >
    }
  </app-taxonomy>
</div>
<main class="configuration">
  <div
    routerLink="/perfil/planos"
    class="configuration-plans-banner"
    *ngIf="showPlanBannerOn(['/perfil/aparencia', '/perfil/emails']) && currentUser && !currentUser.subscription?.has_premium_features"
  >
    <i class="fa-regular fa-arrow-circle-up"></i> {{ 'menu.customizeEmailAppearanceWithCorporatePlan' | translate }}
  </div>
  <div routerLink="/perfil/planos" class="configuration-plans-banner" *ngIf="showPlanBannerOn(['/perfil/personalizacao']) && currentUser && !currentUser.subscription?.has_premium_features">
    <i class="fa-regular fa-arrow-circle-up"></i> {{ 'menu.subscribeToWhitelabelPlan' | translate }}
  </div>

  <router-outlet></router-outlet>
</main>
